import CountDown from '@/components/CountDown.vue';

let dayjs = require('dayjs');

export default {
  name: 'EventsBlock',
  props: {
    events: Object
  },
  components: {
    CountDown
  },

  data() {
    var _this$events, _this$events$events;

    let eventsResult = (_this$events = this.events) === null || _this$events === void 0 ? void 0 : (_this$events$events = _this$events.events) === null || _this$events$events === void 0 ? void 0 : _this$events$events.map(event => {
      var _target;

      let now = dayjs(),
          start = dayjs.tz(event.start),
          end = dayjs.tz(event.end),
          target,
          state;

      if (event.periodic) {
        state = event.state;
        target = dayjs().tz().day(event.day).hour(0).minute(0).second(0).millisecond(0);

        if (event.state == 'start') {
          state = this.$t('common.eventStart');
          target = target.hour(5);
        } else state = this.$t('common.eventEnd');

        if (event.day <= now.day()) target = target.add(1, 'week');
      } else {
        // eslint-disable-next-line
        ;
        ({
          state,
          target
        } = now.isBefore(start) ? {
          state: this.$t('common.eventStart'),
          target: start
        } : now.isBefore(end) ? {
          state: this.$t('common.eventEnd'),
          target: end
        } : {
          state: undefined,
          target: undefined
        });
      }

      return { ...event,
        state,
        time: (_target = target) === null || _target === void 0 ? void 0 : _target.diff(now)
      };
    });
    let available = false;
    eventsResult === null || eventsResult === void 0 ? void 0 : eventsResult.forEach(event => {
      available |= event.state !== undefined;
    });
    return {
      available,
      eventsResult
    };
  }

};